import scroll from "common/helper/scroll";
export default {
    /**
     * Cause selected items to scroll into view.
     * @private
     */
    _prepareSelectScroll: function() {
        this.bind("change", function() {
            var s = this.select();
            if (s.length && this.content && this.content.length) {
                scroll.scrollToElement(s[0], this.content[0]);
            }
        });
    },
};
